import { Buffer } from "buffer"
import { humanFileSize } from "../../../data-utils/uiUtils.js"
import { MAX_ALLOWED_FILE_SIZE_BYTES } from "./dynamic-form.constants"

export const CSV_IMPORT_ERRORS = Object.freeze({
  BAD_FILE: `Couldn't import the file! Check that the file contains CSV content (.txt or .csv) and doesn't exceed the maximum size of ${humanFileSize(
    MAX_ALLOWED_FILE_SIZE_BYTES,
    true,
    2
  )}.`,
})

export const parseFileFormData = async (fileObject) => {
  const fieldData = {
    name: "",
    sizeBytes: 0,
    base64: "",
    utf8: "",
  }
  if (fileObject) {
    fieldData.name = fileObject.name
    fieldData.sizeBytes = fileObject.size
    // Don't attempt to parse anything above the max size
    if (fieldData.sizeBytes <= MAX_ALLOWED_FILE_SIZE_BYTES) {
      const dataBuffer = Buffer.from(await fileObject.arrayBuffer())
      fieldData.base64 = dataBuffer.toString("base64")
      fieldData.utf8 = dataBuffer.toString("utf-8")
    }
  }
  return fieldData
}

const normalizeLineEndings = (str, normalized = "\n") => str.replace(/\r?\n/g, normalized)

export const csvFileToArray = (csvData = "") => {
  // Normalize the line endings to '\n'
  const normalizedCSVData = normalizeLineEndings(csvData, "\n")
  const csvHeader = normalizedCSVData?.slice(0, normalizedCSVData.indexOf("\n")).split(",")
  const csvRows = normalizedCSVData?.slice(normalizedCSVData.indexOf("\n") + 1).split("\n") ?? []

  const csvDataArray = csvRows.map((i) => {
    const values = i.split(",")
    const obj = csvHeader.reduce((object, header, index) => {
      object[header] = values[index]
      return object
    }, {})
    return obj
  })

  return csvDataArray
}

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = () => {
      const arrayBuffer = reader.result
      const bytes = new Uint8Array(arrayBuffer)
      let binary = ""
      for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      const base64 = btoa(binary)
      resolve(base64)
    }
    reader.onerror = (error) => reject(error)
  })
}

export const buildDataUrl = (mediaType, fileName, base64Content) => {
  return `data:${mediaType};filename=${encodeURIComponent(fileName)};base64,${base64Content}`
}
